import { render } from "./SplashScreen.vue?vue&type=template&id=52487c38"
const script = {}

import "./SplashScreen.vue?vue&type=style&index=0&id=52487c38&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__